import React from 'react';
import { Button } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { toast } from 'react-toastify';
import axiosInstance from '../../Utils/axiosInstance';
import { backendbaseUrl } from '../../Utils/baseUrl';

interface BrokerTemplateDownloadButtonProps {
  apiEndpoint: string; // Required prop for the API endpoint
  buttonText?: string; // Optional prop to customize button text
  fileName?: string; // Optional prop to customize the downloaded file name
  sx?: object; // Optional prop for custom styling
}

const BrokerTemplateDownloadButton: React.FC<BrokerTemplateDownloadButtonProps> = ({
  apiEndpoint,
  buttonText = 'Download Template',
  fileName = 'template.csv',
  sx = {
    height: { xs: '36px', sm: '32px' },
    flex: { sm: '0 0 auto' },
    textTransform: 'none',
    fontSize: '0.75rem',
  },
}) => {
  const handleDownloadTemplate = async () => {
    try {
      const response = await axiosInstance.get(
        `${backendbaseUrl}${apiEndpoint}`,
        {
          responseType: 'blob', // Important for handling file downloads
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      // Check if response is valid
      if (!response.data) {
        throw new Error('No data received from server');
      }

      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      // Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      toast.success("template downloaded successfully");
    } catch (error) {
      console.error('Template download error:', error);
      toast.error(`Failed to download ${buttonText.toLowerCase()}`);
    }
  };

  return (
    <Button
      startIcon={<FileDownloadIcon />}
      onClick={handleDownloadTemplate}
      sx={sx}
    >
      {buttonText}
    </Button>
  );
};

export default BrokerTemplateDownloadButton;